import React from 'react';
import Separator from '../../components/Separator';
import {
  Row,
  Address,
  Container,
  Column,
  Banner,
  Email,
  HomeIcon,
  MailIcon,
  TextColumn,
} from './styles';

const Contact = () => {
  return (
    <>
      <Banner>
        <h1> Lojas </h1>
      </Banner>
      <Container>
        <Row>
          <Column>
            <Address>
              <Row>
                <Column>
                  <HomeIcon />
                </Column>
                <TextColumn>
                  Avenida General Flores da Cunha, 1240, Centro <br />
                  Cachoeirinha/RS
                  <br />
                </TextColumn>
              </Row>
            </Address>
          </Column>
        </Row>
        <Row>
          <Column>
            <Address>
              <Row>
                <Column>
                  <HomeIcon />
                </Column>
                <TextColumn>
                  Avenida Alexandrino de Alencar, 1156, MV1 <br />
                  Gravataí/RS
                  <br />
                </TextColumn>
              </Row>
            </Address>
          </Column>
        </Row>
        <Row>
          <Column>
            <Address>
              <Row>
                <Column>
                  <HomeIcon />
                </Column>
                <TextColumn>
                  Avenida Dorival Cândido Luz de Oliveira, 5360 <br />
                  Gravataí/RS
                  <br />
                </TextColumn>
              </Row>
            </Address>
          </Column>
        </Row>
        <Row>
          <Column>
            <Address>
              <Row>
                <Column>
                  <HomeIcon />
                </Column>
                <TextColumn>
                  Rua Anápio Gomes, 1419, Centro <br />
                  Gravataí/RS
                  <br />
                </TextColumn>
              </Row>
            </Address>
          </Column>
        </Row>
        <Row>
          <Column>
            <Address>
              <Row>
                <Column>
                  <HomeIcon />
                </Column>
                <TextColumn>
                  Rua Quinze de Janeiro, 128, Centro <br />
                  Canoas/RS
                  <br />
                </TextColumn>
              </Row>
            </Address>
          </Column>
        </Row>
        <Row>
          <Column>
            <Email>
              <Row>
                <Column>
                  <MailIcon />
                </Column>
                <TextColumn>contato@sorveterianewaska.com.br</TextColumn>
              </Row>
            </Email>
          </Column>
        </Row>
        <Row>
          <Column></Column>
        </Row>
      </Container>
      <Separator />
    </>
  );
};

export default Contact;
